import ISpineAnimConfig from "../../vendor_core/core/src/managers/contracts/configurations/spine_anim/ISpineAnimConfig";
import AbstractBaseSpineAnimationsConfig from "../../vendor_core/core/src/baseConfigs/AbstractSceneSpineAnimationsConfig";
import ISceneSpineAnimConfig from "../../vendor_core/core/src/managers/contracts/configurations/ISceneSpineAnimConfig";

class SpineAnimationsConfig
    extends AbstractBaseSpineAnimationsConfig
    implements ISceneSpineAnimConfig
{
    anims: ISpineAnimConfig[] = [
        {
            name: "bigWin",
            hasSkins: false,
            states: [
                {
                    name: "bigwin_loop",
                    loop: false
                },
                {
                    name: "epicwin_loop",
                    loop: false
                },
                {
                    name: "megawin_loop",
                    loop: false
                },
                {
                    name: "superwin_loop",
                    loop: false
                },
                {
                    name: "bigwin_loop_pt",
                    loop: false
                },
                {
                    name: "epicwin_loop_pt",
                    loop: false
                },
                {
                    name: "megawin_loop_pt",
                    loop: false
                },
                {
                    name: "superwin_loop_pt",
                    loop: false
                },
                {
                    name: "bigwin_end",
                    loop: false
                },
                {
                    name: "epicwin_end",
                    loop: false
                },
                {
                    name: "megawin_end",
                    loop: false
                },
                {
                    name: "superwin_end",
                    loop: false
                },
                {
                    name: "bigwin_end_pt",
                    loop: false
                },
                {
                    name: "epicwin_end_pt",
                    loop: false
                },
                {
                    name: "megawin_end_pt",
                    loop: false
                },
                {
                    name: "superwin_end_pt",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "start",
            playDefault: false,
            forceRepositionContainer: true
        },
        {
            name: "symbolDestruction",
            hasSkins: false,
            states: [
                {
                    name: "destruction",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "destruction",
            playDefault: false,
            forceRepositionContainer: false
        },
        {
            name: "replayPopup",
            hasSkins: false,
            states: [
                {
                    name: "replay_feature",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "replay_feature",
            playDefault: false,
            forceRepositionContainer: true
        },
        {
            name: "RedChest",
            hasSkins: true,
            states: [
                {
                    name: "chest_level1_idle",
                    loop: true
                },
                {
                    name: "chest_level2_idle",
                    loop: true
                },
                {
                    name: "chest_level3_idle",
                    loop: true
                },
                {
                    name: "chest_level4_idle",
                    loop: true
                },
                {
                    name: "chest_level5_idle",
                    loop: true
                },
                {
                    name: "chest_level6_idle",
                    loop: true
                },
                {
                    name: "chest_level7_idle",
                    loop: true
                },
                {
                    name: "chest_level8_idle",
                    loop: true
                },
                {
                    name: "chest_level9_idle",
                    loop: true
                },
                {
                    name: "chest_level10_idle",
                    loop: true
                },
                {
                    name: "level1_to_2",
                    loop: false
                },
                {
                    name: "level2_to_3",
                    loop: false
                },
                {
                    name: "level3_to_4",
                    loop: false
                },
                {
                    name: "level4_to_5",
                    loop: false
                },
                {
                    name: "level5_to_6",
                    loop: false
                },
                {
                    name: "level6_to_7",
                    loop: false
                },
                {
                    name: "level7_to_8",
                    loop: false
                },
                {
                    name: "level8_to_9",
                    loop: false
                },
                {
                    name: "level9_to_10",
                    loop: false
                },
                {
                    name: "reset_level_2",
                    loop: false
                },
                {
                    name: "reset_level_3",
                    loop: false
                },
                {
                    name: "reset_level_4",
                    loop: false
                },
                {
                    name: "reset_level_5",
                    loop: false
                },
                {
                    name: "reset_level_6",
                    loop: false
                },
                {
                    name: "reset_level_7",
                    loop: false
                },
                {
                    name: "reset_level_8",
                    loop: false
                },
                {
                    name: "reset_level_9",
                    loop: false
                },
                {
                    name: "reset_level_10",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "chest_level1_idle",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "YellowChest",
            hasSkins: true,
            states: [
                {
                    name: "chest_level1_idle",
                    loop: true
                },
                {
                    name: "chest_level2_idle",
                    loop: true
                },
                {
                    name: "chest_level3_idle",
                    loop: true
                },
                {
                    name: "chest_level4_idle",
                    loop: true
                },
                {
                    name: "chest_level5_idle",
                    loop: true
                },
                {
                    name: "chest_level6_idle",
                    loop: true
                },
                {
                    name: "chest_level7_idle",
                    loop: true
                },
                {
                    name: "chest_level8_idle",
                    loop: true
                },
                {
                    name: "chest_level9_idle",
                    loop: true
                },
                {
                    name: "chest_level10_idle",
                    loop: true
                },
                {
                    name: "level1_to_2",
                    loop: false
                },
                {
                    name: "level2_to_3",
                    loop: false
                },
                {
                    name: "level3_to_4",
                    loop: false
                },
                {
                    name: "level4_to_5",
                    loop: false
                },
                {
                    name: "level5_to_6",
                    loop: false
                },
                {
                    name: "level6_to_7",
                    loop: false
                },
                {
                    name: "level7_to_8",
                    loop: false
                },
                {
                    name: "level8_to_9",
                    loop: false
                },
                {
                    name: "level9_to_10",
                    loop: false
                },
                {
                    name: "reset_level_2",
                    loop: false
                },
                {
                    name: "reset_level_3",
                    loop: false
                },
                {
                    name: "reset_level_4",
                    loop: false
                },
                {
                    name: "reset_level_5",
                    loop: false
                },
                {
                    name: "reset_level_6",
                    loop: false
                },
                {
                    name: "reset_level_7",
                    loop: false
                },
                {
                    name: "reset_level_8",
                    loop: false
                },
                {
                    name: "reset_level_9",
                    loop: false
                },
                {
                    name: "reset_level_10",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "chest_level1_idle",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "BlueChest",
            hasSkins: true,
            states: [
                {
                    name: "chest_level1_idle",
                    loop: true
                },
                {
                    name: "chest_level2_idle",
                    loop: true
                },
                {
                    name: "chest_level3_idle",
                    loop: true
                },
                {
                    name: "chest_level4_idle",
                    loop: true
                },
                {
                    name: "chest_level5_idle",
                    loop: true
                },
                {
                    name: "chest_level6_idle",
                    loop: true
                },
                {
                    name: "chest_level7_idle",
                    loop: true
                },
                {
                    name: "chest_level8_idle",
                    loop: true
                },
                {
                    name: "chest_level9_idle",
                    loop: true
                },
                {
                    name: "chest_level10_idle",
                    loop: true
                },
                {
                    name: "level1_to_2",
                    loop: false
                },
                {
                    name: "level2_to_3",
                    loop: false
                },
                {
                    name: "level3_to_4",
                    loop: false
                },
                {
                    name: "level4_to_5",
                    loop: false
                },
                {
                    name: "level5_to_6",
                    loop: false
                },
                {
                    name: "level6_to_7",
                    loop: false
                },
                {
                    name: "level7_to_8",
                    loop: false
                },
                {
                    name: "level8_to_9",
                    loop: false
                },
                {
                    name: "level9_to_10",
                    loop: false
                },
                {
                    name: "reset_level_2",
                    loop: false
                },
                {
                    name: "reset_level_3",
                    loop: false
                },
                {
                    name: "reset_level_4",
                    loop: false
                },
                {
                    name: "reset_level_5",
                    loop: false
                },
                {
                    name: "reset_level_6",
                    loop: false
                },
                {
                    name: "reset_level_7",
                    loop: false
                },
                {
                    name: "reset_level_8",
                    loop: false
                },
                {
                    name: "reset_level_9",
                    loop: false
                },
                {
                    name: "reset_level_10",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "chest_level1_idle",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "energyFrame",
            hasSkins: false,
            states: [
                {
                    name: "end",
                    loop: false
                },
                {
                    name: "Idle",
                    loop: true
                },
                {
                    name: "start",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "start",
            playDefault: false,
            forceRepositionContainer: false
        },
        {
            name: "transformWild",
            hasSkins: false,
            states: [
                {
                    name: "animation",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "animation",
            playDefault: false,
            forceRepositionContainer: false
        },
        {
            name: "buffalo",
            hasSkins: false,
            states: [
                {
                    name: "red",
                    loop: false
                },
                {
                    name: "yellow",
                    loop: false
                },
                {
                    name: "blue",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "red",
            playDefault: false,
            forceRepositionContainer: true
        },
        {
            name: "energy",
            hasSkins: true,
            states: [
                {
                    name: "cell_1",
                    loop: true
                },
                {
                    name: "cell_2",
                    loop: false
                },
                {
                    name: "cell_3",
                    loop: false
                },
                {
                    name: "cell_4",
                    loop: false
                },
                {
                    name: "cell_5",
                    loop: false
                },
                {
                    name: "cell_6",
                    loop: false
                },
                {
                    name: "cell_7",
                    loop: false
                },
                {
                    name: "cell_8",
                    loop: false
                },
                {
                    name: "cell_9",
                    loop: false
                },
                {
                    name: "cell_10",
                    loop: false
                },
                {
                    name: "cell_11",
                    loop: false
                },
                {
                    name: "cell_12",
                    loop: false
                },
                {
                    name: "cell_13",
                    loop: false
                },
                {
                    name: "cell_14",
                    loop: false
                },
                {
                    name: "cell_15",
                    loop: false
                },
                {
                    name: "cell_16",
                    loop: false
                },
                {
                    name: "cell_17",
                    loop: false
                },
                {
                    name: "cell_18",
                    loop: false
                },
                {
                    name: "cell_19",
                    loop: false
                },
                {
                    name: "cell_20",
                    loop: false
                },
                {
                    name: "cell_21",
                    loop: false
                },
                {
                    name: "cell_22",
                    loop: false
                },
                {
                    name: "cell_23",
                    loop: false
                },
                {
                    name: "cell_24",
                    loop: false
                }
            ],
            visible: false,
            defaultState: "cell_1",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "freespinsIntroOutro",
            hasSkins: true,
            states: [
                {
                    name: "intro_end",
                    loop: false
                },
                {
                    name: "intro_end_pt",
                    loop: false
                },
                {
                    name: "intro_loop",
                    loop: false
                },
                {
                    name: "intro_loop_pt",
                    loop: false
                },
                {
                    name: "intro_start",
                    loop: false
                },
                {
                    name: "intro_start_pt",
                    loop: false
                },
                {
                    name: "outro_end",
                    loop: false
                },
                {
                    name: "outro_end_pt",
                    loop: false
                },
                {
                    name: "outro_loop",
                    loop: false
                },
                {
                    name: "outro_loop_pt",
                    loop: false
                },
                {
                    name: "outro_start",
                    loop: false
                },
                {
                    name: "outro_start_pt",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "intro_start",
            playDefault: false,
            forceRepositionContainer: true,
            scaleMultiplier: [
                {
                    animation: "intro_end_pt",
                    y: 0.85,
                    x: 0.85
                },
                {
                    animation: "intro_loop_pt",
                    y: 0.85,
                    x: 0.85
                },
                {
                    animation: "intro_start_pt",
                    y: 0.85,
                    x: 0.85
                },
                {
                    animation: "outro_end_pt",
                    y: 0.68,
                    x: 0.68
                },
                {
                    animation: "outro_loop_pt",
                    y: 0.68,
                    x: 0.68
                },
                {
                    animation: "outro_start_pt",
                    y: 0.68,
                    x: 0.68
                }
            ]
        },
        {
            name: "background",
            hasSkins: false,
            states: [
                {
                    name: "main",
                    loop: true
                },
                {
                    name: "main_pt",
                    loop: true
                }
            ],
            visible: true,
            defaultState: "main",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "energyMeters",
            hasSkins: true,
            states: [
                {
                    name: "start_x1",
                    loop: false
                },
                {
                    name: "start_x1_pt",
                    loop: false
                },
                {
                    name: "start_x2",
                    loop: false
                },
                {
                    name: "start_x2_pt",
                    loop: false
                },
                {
                    name: "start_x3",
                    loop: false
                },
                {
                    name: "start_x3_pt",
                    loop: false
                },
                {
                    name: "start_x5",
                    loop: false
                },
                {
                    name: "start_x5_pt",
                    loop: false
                },
                {
                    name: "loop_x1",
                    loop: true
                },
                {
                    name: "loop_x1_pt",
                    loop: true
                },
                {
                    name: "loop_x2",
                    loop: true
                },
                {
                    name: "loop_x2_pt",
                    loop: true
                },
                {
                    name: "loop_x3",
                    loop: true
                },
                {
                    name: "loop_x3_pt",
                    loop: true
                },
                {
                    name: "loop_x5",
                    loop: true
                },
                {
                    name: "loop_x5_pt",
                    loop: true
                },
                {
                    name: "end_x1",
                    loop: false
                },
                {
                    name: "end_x1_pt",
                    loop: false
                },
                {
                    name: "end_x2",
                    loop: false
                },
                {
                    name: "end_x2_pt",
                    loop: false
                },
                {
                    name: "end_x3",
                    loop: false
                },
                {
                    name: "end_x3_pt",
                    loop: false
                },
                {
                    name: "end_x5",
                    loop: false
                },
                {
                    name: "end_x5_pt",
                    loop: false
                },
                {
                    name: "win_x1",
                    loop: false
                },
                {
                    name: "win_x1_pt",
                    loop: false
                },
                {
                    name: "win_x2",
                    loop: false
                },
                {
                    name: "win_x2_pt",
                    loop: false
                },
                {
                    name: "win_x3",
                    loop: false
                },
                {
                    name: "win_x3_pt",
                    loop: false
                },
                {
                    name: "win_x5",
                    loop: false
                },
                {
                    name: "win_x5_pt",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "loop_x1",
            playDefault: true,
            forceRepositionContainer: true,
            scaleMultiplier: [
                {
                    animation: "start_x1",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "start_x1_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "start_x2",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "start_x2_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "start_x3",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "start_x3_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "start_x5",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "start_x5_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "loop_x1",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "loop_x1_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "loop_x2",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "loop_x2_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "loop_x3",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "loop_x3_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "loop_x5",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "loop_x5_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "end_x1",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "end_x1_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "end_x2",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "end_x2_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "end_x3",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "end_x3_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "end_x5",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "end_x5_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "win_x1",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "win_x1_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "win_x2",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "win_x2_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "win_x3",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "win_x3_pt",
                    y: 0.9,
                    x: 0.9
                },
                {
                    animation: "win_x5",
                    y: 0.98,
                    x: 0.98
                },
                {
                    animation: "win_x5_pt",
                    y: 0.9,
                    x: 0.9
                }
            ]
        },
        {
            name: "jackpotWins",
            hasSkins: true,
            states: [
                {
                    name: "start",
                    loop: false
                },
                {
                    name: "start_pt",
                    loop: false
                },
                {
                    name: "loop",
                    loop: true
                },
                {
                    name: "loop_pt",
                    loop: true
                },
                {
                    name: "end",
                    loop: false
                },
                {
                    name: "end_pt",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "start",
            playDefault: false,
            forceRepositionContainer: false
        },
        {
            name: "minorJackpotPlate",
            hasSkins: false,
            states: [
                {
                    name: "minor_idle_empty",
                    loop: true
                },
                {
                    name: "minor_idle_full1",
                    loop: true
                },
                {
                    name: "minor_idle_full2",
                    loop: true
                },
                {
                    name: "minor_idle_full3",
                    loop: true
                },
                {
                    name: "minor_win1",
                    loop: false
                },
                {
                    name: "minor_win2",
                    loop: false
                },
                {
                    name: "minor_win3",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "minor_idle_empty",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "mediumJackpotPlate",
            hasSkins: false,
            states: [
                {
                    name: "medium_idle_empty",
                    loop: true
                },
                {
                    name: "medium_idle_full1",
                    loop: true
                },
                {
                    name: "medium_idle_full2",
                    loop: true
                },
                {
                    name: "medium_idle_full3",
                    loop: true
                },
                {
                    name: "medium_idle_full4",
                    loop: true
                },
                {
                    name: "medium_win1",
                    loop: false
                },
                {
                    name: "medium_win2",
                    loop: false
                },
                {
                    name: "medium_win3",
                    loop: false
                },
                {
                    name: "medium_win4",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "medium_idle_empty",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "megaJackpotPlate",
            hasSkins: false,
            states: [
                {
                    name: "mega_idle_empty",
                    loop: true
                },
                {
                    name: "mega_idle_full1",
                    loop: true
                },
                {
                    name: "mega_idle_full2",
                    loop: true
                },
                {
                    name: "mega_idle_full3",
                    loop: true
                },
                {
                    name: "mega_idle_full4",
                    loop: true
                },
                {
                    name: "mega_idle_full5",
                    loop: true
                },
                {
                    name: "mega_idle_full6",
                    loop: true
                },
                {
                    name: "mega_win1",
                    loop: false
                },
                {
                    name: "mega_win2",
                    loop: false
                },
                {
                    name: "mega_win3",
                    loop: false
                },
                {
                    name: "mega_win4",
                    loop: false
                },
                {
                    name: "mega_win5",
                    loop: false
                },
                {
                    name: "mega_win6",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "mega_idle_empty",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "majorJackpotPlate",
            hasSkins: false,
            states: [
                {
                    name: "major_idle_empty",
                    loop: true
                },
                {
                    name: "major_idle_full1",
                    loop: true
                },
                {
                    name: "major_idle_full2",
                    loop: true
                },
                {
                    name: "major_idle_full3",
                    loop: true
                },
                {
                    name: "major_idle_full4",
                    loop: true
                },
                {
                    name: "major_idle_full5",
                    loop: true
                },
                {
                    name: "major_win1",
                    loop: false
                },
                {
                    name: "major_win2",
                    loop: false
                },
                {
                    name: "major_win3",
                    loop: false
                },
                {
                    name: "major_win4",
                    loop: false
                },
                {
                    name: "major_win5",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "major_idle_empty",
            playDefault: true,
            forceRepositionContainer: false
        },
        {
            name: "miniJackpotPlate",
            hasSkins: false,
            states: [
                {
                    name: "mini_idle_empty",
                    loop: true
                },
                {
                    name: "mini_idle_full1",
                    loop: true
                },
                {
                    name: "mini_idle_full2",
                    loop: true
                },
                {
                    name: "mini_win1",
                    loop: false
                },
                {
                    name: "mini_win2",
                    loop: false
                }
            ],
            visible: true,
            defaultState: "mini_idle_empty",
            playDefault: true,
            forceRepositionContainer: false
        }
    ];
}

export default new SpineAnimationsConfig();
